module.exports = __webpack_public_path__ + "static/media/Infinity-loader.fea3e9fb.svg";